import React, { useRef, useState } from "react";
import { MenuItem, MenuList } from "@mui/material";
import { CustomButton, CustomTooltip, DropDown, icon } from "../../../../../../../../common/components";
import styles from "./RichtextEditor.module.css";

const DropDownAction = ({ disabled = false, isSelected = false, items, onCancel, onSelect, tooltip = "", value }) => {
	const anchorRef = useRef(null);
	const [open, setOpen] = useState(false);
	const handleOpen = () => {
		if (isSelected && onCancel) {
			onCancel();
			setOpen(false);
		} else {
			setOpen(!open);
		}
	};
	const handleSelect = (po) => {
		onSelect(po);
		handleOpen();
	};
	return (
		<>
			<CustomTooltip title={tooltip}>
				<CustomButton
					ref={anchorRef}
					className={`${styles.actionButton} ${styles.dropDownAction}`}
					color={isSelected ? "primary" : "secondary"}
					disabled={disabled}
					endIcon={open ? icon.faChevronUp : icon.faChevronDown}
					size="xs"
					onClick={handleOpen}
				>
					{value}
				</CustomButton>
			</CustomTooltip>
			<DropDown ref={anchorRef} open={open} onClose={handleOpen}>
				<MenuList>
					{items.map((po) => (
						<MenuItem key={po.value} onClick={() => handleSelect(po.value)}>
							{po.label}
						</MenuItem>
					))}
				</MenuList>
			</DropDown>
		</>
	);
};

export default DropDownAction;
